import { render, staticRenderFns } from "./VipUpsellButton.vue?vue&type=template&id=52985db0&scoped=true&"
import script from "./VipUpsellButton.vue?vue&type=script&lang=js&"
export * from "./VipUpsellButton.vue?vue&type=script&lang=js&"
import style0 from "./VipUpsellButton.vue?vue&type=style&index=0&id=52985db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52985db0",
  null
  
)

export default component.exports